// extracted by mini-css-extract-plugin
export default {"login-page":"LoginPage_login-page__c4Tp8","app-logo":"LoginPage_app-logo__5BKKq","panel":"LoginPage_panel__8a-ZW"};